import {CorporationEntity} from "./CorporationEntity";
import {TopicEntity} from "./TopicEntity";
import {SubjectEntity} from "./SubjectEntity";

export class CourseEntity {
  corpId: number;
  id: number;
  alias: string;
  name: string;
  startDate: string;
  endDate: string;
  defaultRole: number;
  defaultCalendar: string;
  coursePucharse: boolean;
  forumId: number;
  categoryId: number;
  officialExamId: number;
  requestAddress: boolean;
  requestExp: boolean;
  registerOrder: number;
  openSignupDate: string;
  closeSignupDate: string;
  answerTemplateUrl: string;
  contentNotification: boolean;
  showExamSubjectDifficult: boolean;
  showInRegister: boolean;
  showInCampus: boolean;
  showInMagnament: boolean;

  tagCloudQuestionGroups: string;
  subjectQuestionGroups: string;
  flashcardGroups: string;

  battleQuestionGroups: string;
  battleShortNumQuestions: number;
  battleShortDuration: number;
  battleMediumNumQuestions: number;
  battleMediumDuration: number;
  battleLongNumQuestions: number;
  battleLongDuration: number;
}
